import * as Yup from 'yup';
import { QUANTITY_MODES, VALIDATION_MESSAGES } from './constants';

// eslint-disable-next-line import/prefer-default-export
export const PRODUCT_DETAILS_SCHEMA = Yup.object().shape({
  quantityMode: Yup.string().required(VALIDATION_MESSAGES.REQUIRED),
  ratePerAcre: Yup.number().when('quantityMode', {
    is: QUANTITY_MODES.RATE_PER_ACRE,
    then: Yup.number()
      .required(VALIDATION_MESSAGES.REQUIRED)
      .test(
        'positive',
        VALIDATION_MESSAGES.NEGATIVE_NUMBER,
        value => !value || Number.parseFloat(value) > 0
      ),
    otherwise: Yup.number().notRequired()
  }),
  ratePerTank: Yup.number().when('quantityMode', {
    is: QUANTITY_MODES.RATE_PER_TANK,
    then: Yup.number()
      .required(VALIDATION_MESSAGES.REQUIRED)
      .test(
        'positive',
        VALIDATION_MESSAGES.NEGATIVE_NUMBER,
        value => !value || Number.parseFloat(value) > 0
      ),
    otherwise: Yup.number().notRequired()
  }),
  totalProduct: Yup.number().when('quantityMode', {
    is: QUANTITY_MODES.TOTAL_PRODUCT,
    then: Yup.number()
      .required(VALIDATION_MESSAGES.REQUIRED)
      .test(
        'positive',
        VALIDATION_MESSAGES.NEGATIVE_NUMBER,
        value => !value || Number.parseFloat(value) > 0
      ),
    otherwise: Yup.number().notRequired()
  }),
  appliedAreaValue: Yup.number()
    .required(VALIDATION_MESSAGES.REQUIRED)
    .test(
      'positive',
      VALIDATION_MESSAGES.NEGATIVE_NUMBER,
      value => !value || Number.parseFloat(value) > 0
    ),
  coveragePercent: Yup.number()
    .required(VALIDATION_MESSAGES.REQUIRED)
    .test('range', 'Must be between 0 and 100', value => {
      if (!value) return false;
      const num = Number.parseFloat(value);
      return num > 0 && num <= 100;
    }),
  priceValue: Yup.number().test(
    'positive',
    VALIDATION_MESSAGES.NEGATIVE_NUMBER,
    value => !value || Number.parseFloat(value) >= 0
  )
});
